import { createFileRoute } from "@tanstack/react-router";
import Solutions from "@/pages/Solutions";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/solutions")({
  head: () => pageHead("/solutions", "en"),
  component: Solutions,
});
